import { Link, useParams } from "react-router-dom";
import Page from "../components/page";
import moment from "moment";
import api from "../functions/api";

const AttendanceDetails = () => {
    let { data } = useParams();

    data = JSON.parse(atob(data));
    console.log("🚀 ~ AttendanceDetails ~ data:", data);

    return (
        <Page title="Attendace Details" className="attendance-details">
            <div className="style-4">
                <div className="style-14">Emp Id :</div>
                <div className="style-17">{data?._id}</div>
            </div>

            <div className="style-13">
                <div className="style-14">Name :</div>
                <div className="style-17">{data?.employeeName}</div>
            </div>

            <div className="style-13">
                <div className="style-14">Date :</div>
                <div className="style-17">
                    {moment(data?.createdAt).format("DD/MM/YYYY hh:mm a")}
                </div>
            </div>

            <div className="style-13">
                <div className="style-14">Machine Id :</div>
                <div className="style-17">{data?.machineName}</div>
            </div>

            <div className="style-13">
                <div className="style-14">Shift :</div>
                <div className="style-17">
                    {data?.shift == 0 ? "DAY" : "NIGHT"}
                </div>
            </div>

            <div className="style-13">
                <div className="style-14">Production :</div>
                <div className="style-17">{data?.production}</div>
            </div>

            <div className="style-13">
                <div className="style-14">Frame :</div>
                <div className="style-17">{data?.frame}</div>
            </div>

            <div className="style-13">
                <div className="style-14">Dhaga :</div>
                <div className="style-17">{data?.dhaga}</div>
            </div>

            <div className="photos">
                <div className="style-14">Photo :</div>
                <img
                    src={`${api.baseURL}/media/${data?.photo}`}
                    className="photo"
                />
            </div>
        </Page>
    );
};

export default AttendanceDetails;
